import { createAsyncThunk } from '@reduxjs/toolkit'
import { errorGlobal, successGlobal } from '../reducers/notifications';
import { getUserData } from '../../utils/tools';
import { getAuthHeader,getAuthHeaderforimage } from '../../utils/tools';
import axios from 'axios';
import { updateMnCategories } from '../reducers/shopReducer';
import JSONBigInt from 'json-bigint';


axios.defaults.headers.post['Content-Type'] = 'application/json';
const BASE_URL="https://backend.nativehelper.com/news/"

//const BASE_URL="http://103.133.215.247:8080/news/"
//const BASE_URL="http://192.168.1.5:8080/"


//GET SHOP PAGINATION
export const getPaginateitems= createAsyncThunk(
    'itemsReducer/getPaginateitems',
    async({page=0,limit=10,keywords=''},{ dispatch })=>{
        try{

        
            // const url=`${BASE_URL}api/onlitms/ofcitems?page=${page}&size=${limit}&sort=createdDate,desc`;
            // console.log("333333333");

            // console.log(page);
            // console.log("333333333");


             let url=null;
                        if(!((getUserData().role==="ROLE_SHOPRPTR") || (getUserData().role==="ROLE_SHOPEDTR"))){
                            url =`${BASE_URL}api/onlitms/ofcitems?page=${page}&size=${limit}&sort=createdDate,desc`;            
                        }
                        else{
                            url =`${BASE_URL}api/onlitms/ofcitemss?userID=${getUserData().userId}&page=${page}&size=${limit}&sort=createdDate,desc`;    
                        }

          //  http://localhost:8080/api/news/tutorials?page=0&size=20&sort=createdDate,desc&sort=newsHeading,asc
            const request = await axios.get(url,getAuthHeader()).then(
                console.log("12121212121"),
                (data) => console.log(data),
                console.log("12121212121"),
               
              );
            console.log("6666666");
            console.log(request);
            console.log("6666666");
            console.log(request.data);
            console.log("6666");

            let r1 = JSONBigInt.parse(request.request.response);
            let jsonStr=JSONBigInt.stringify(r1);
            

            const jsonStr1= jsonStr.replace(new RegExp('"onlineId":([0-9]+),',"g"),'"onlineId":"$1",')
            const jsonStr2= jsonStr1.replace(new RegExp('"shopId":([0-9]+),',"g"),'"shopId":"$1",')
             const ddd=JSON.parse(jsonStr2);
             console.log("545445");
             console.log(ddd);
             console.log("5454454");

            return ddd;
        } catch(error){
            dispatch(errorGlobal(error.response.data.message))
            throw error
        }
    }
)

export const getShopsByMcatID = createAsyncThunk(
    'itemsReducer/getShopsByMcatID',
    async(id,{ dispatch })=>{

        //shopsbymcts/{did}/{tid}/{rid}/{mid}
        const url=`${BASE_URL}api/shops/shopsbymctsuser/${getUserData().userId}/${id}`;
        
      console.log("1111111111");
        console.log(url);
        console.log("111111111111111");
       
            try{
                const request = await axios.get(url,getAuthHeader());
                console.log("66666666666");
                console.log(request);
                console.log("666666");
    
                let r1 = JSONBigInt.parse(request.request.response);
                let jsonStr=JSONBigInt.stringify(r1);
                const jsonStr1= jsonStr.replace(new RegExp('"shopId":([0-9]+),',"g"),'"shopId":"$1",')
                 const ddd=JSON.parse(jsonStr1);
                 console.log("66666666666");
                 console.log(ddd);
                 console.log("666666");
                return ddd;
               
                
                
            
            } catch(error){
            dispatch(errorGlobal(error.response.data.message))
            throw error
        }

        
    }
)


//http://localhost:8080/api/items/itminfoadm/1/2

export const getItemMcatIDandSubCat = createAsyncThunk(
    'itemsReducer/getItemMcatIDandSubCat',
    async(_id,{ dispatch })=>{
       
        //shopsbymcts/{did}/{tid}/{rid}/{mid}
        console.log("66666666666");
            console.log(_id);
            console.log("666666");
           
           

    
        let myArray = _id.split("_");
       
 
       let mCat= Number(myArray[0]);
       let subCat= Number(myArray[1]);
        const url=`${BASE_URL}api/items/itminf/${mCat}/${subCat}`;
        
      console.log("1111111111");
        console.log(url);
        console.log("111111111111111");
       
            try{
                const request = await axios.get(url,getAuthHeader());
                console.log("66666666666");
                console.log(request);
                console.log("666666");
    
                let r1 = JSONBigInt.parse(request.request.response);
                let jsonStr=JSONBigInt.stringify(r1);
                const jsonStr1= jsonStr.replace(new RegExp('"shopId":([0-9]+),',"g"),'"shopId":"$1",')
                 const ddd=JSON.parse(jsonStr1);
                 console.log("66666666666");
                 console.log(ddd);
                 console.log("666666");
                return ddd;
               
                
                
            
            } catch(error){
            dispatch(errorGlobal(error.response.data.message))
            throw error
        }

        
    }
)


//http://localhost:8080/api/items/itminfoadm/1/2

export const getAllItems = createAsyncThunk(
    'itemsReducer/getAllItems',
    async(_id,{ dispatch })=>{
       
        //shopsbymcts/{did}/{tid}/{rid}/{mid}
        console.log("66666666666");
            console.log(_id);
            console.log("666666");
           
           

    
        let myArray = _id.split("_");
       
 
       let mCat= Number(myArray[0]);
       let subCat= Number(myArray[1]);
        const url=`${BASE_URL}api/items/itminfoadm`;
        
      console.log("1111111111");
        console.log(url);
        console.log("111111111111111");
       
            try{
                const request = await axios.get(url,getAuthHeader());
                console.log("66666666666");
                console.log(request);
                console.log("666666");
    
                let r1 = JSONBigInt.parse(request.request.response);
                let jsonStr=JSONBigInt.stringify(r1);
                const jsonStr1= jsonStr.replace(new RegExp('"shopId":([0-9]+),',"g"),'"shopId":"$1",')
                 const ddd=JSON.parse(jsonStr1);
                 console.log("66666666666");
                 console.log(ddd);
                 console.log("666666");
                return ddd;
               
                
                
            
            } catch(error){
            dispatch(errorGlobal(error.response.data.message))
            throw error
        }

        
    }
)

export const addItem = createAsyncThunk(
    'itemsReducer/addItem',
    async(item,{ dispatch })=>{

        const Itemdata = {
            
            shopId:item.shopId,
            itemID:item.itemID,
             userId:getUserData().userId,
             languageType:item.languageType,
             mrp:item.mrp,
             price:item.price,
             unit:item.unit,
             brandName:item.brandName,
             discription:item.content,
             finalApproved:getUserData().userId,
             validFrom:item.validFrom,
             validTo:item.validFrom

        };
        const  customConfig = {
        headers: {
        'Content-Type': 'application/json',
        'Authorization':getAuthHeader().headers.Authorization
        
        }
    };


        try{

           console.log("777777777777777777");
            console.log(Itemdata)

   
          
         console.log("888888888888888888888");
           
            const request = await axios.post(`${BASE_URL}api/onlitms/add`,Itemdata,getAuthHeader());
            dispatch(successGlobal('item is  added !!'))
            console.log("888888888888888888888");

            console.log(request.data);
            console.log("888888888888888888888");
            



            let r1 = JSONBigInt.parse(request.request.response);
            let jsonStr=JSONBigInt.stringify(r1);
            const jsonStr1= jsonStr.replace(new RegExp('"id":([0-9]+),',"g"),'"id":"$1",')
             const ddd=JSON.parse(jsonStr1);
            return ddd;
        } catch(error){
            dispatch(errorGlobal(error.response.data.message))
           // console.log("1000000000000000000");
            //console.log(error.response.data);
            console.log("333333333333333333333");
            throw error
        }
    }

    
)

export const updateItem = createAsyncThunk(
    'itemsReducer/updateItem',
    async(item,{ dispatch })=>{

        const Itemdata = {
            onlineId:item.onlineId,
            shopId:item.shopId,
            itemID:item.itemID,
             userId:getUserData().userId,
             languageType:item.languageType,
             mrp:item.mrp,
             price:item.price,
             unit:item.unit,
             brandName:item.brandName,
             discription:item.content,
             finalApproved:getUserData().userId,
             validFrom:item.validFrom,
             validTo:item.validFrom

        };
        const  customConfig = {
        headers: {
        'Content-Type': 'application/json',
        'Authorization':getAuthHeader().headers.Authorization
        
        }
    };


        try{

           console.log("777777777777777777");
            console.log(Itemdata)

   
          
         console.log("888888888888888888888");
           
            const request = await axios.post(`${BASE_URL}api/onlitms/edite`,Itemdata,getAuthHeader());
            dispatch(successGlobal('item is  added !!'))
            console.log("888888888888888888888");

            console.log(request.data);
            console.log("888888888888888888888");
            



            let r1 = JSONBigInt.parse(request.request.response);
            let jsonStr=JSONBigInt.stringify(r1);
            const jsonStr1= jsonStr.replace(new RegExp('"id":([0-9]+),',"g"),'"id":"$1",')
             const ddd=JSON.parse(jsonStr1);
            return ddd;
        } catch(error){
            dispatch(errorGlobal(error.response.data.message))
           // console.log("1000000000000000000");
            //console.log(error.response.data);
            console.log("333333333333333333333");
            throw error
        }
    }

    
)


//GETTING item DETAILS FOR OFFICE USE  
export const getItembyIdOfcView = createAsyncThunk(
    'itemsReducer/getItembyIdOfcView',
    async(id,{ dispatch })=>{
        const url=`${BASE_URL}api/onlitms/itemcmlofc/${id}/${getUserData().userId}`;
        console.log("12121212121")
        console.log(url)

        console.log("12121212121")
        
        try{
            const request = await axios.get(url,getAuthHeader()).then(
                
               
              );
             // JSONbigint.parse(request.data);
             console.log("12121212121")
             console.log(request.data)
     
             console.log("12121212121")

             let r1 = JSONBigInt.parse(request.request.response);
             let jsonStr=JSONBigInt.stringify(r1);
             
 
             const jsonStr1= jsonStr.replace(new RegExp('"onlineId":([0-9]+),',"g"),'"onlineId":"$1",')
             const jsonStr2= jsonStr1.replace(new RegExp('"shopId":([0-9]+),',"g"),'"shopId":"$1",')
              const ddd=JSON.parse(jsonStr2);
              console.log("545445");
              console.log(ddd);
              console.log("5454454");
              return ddd;

         
        } catch(error){
            dispatch(errorGlobal(error.response.data.message))
            throw error
        }

        
    }
)


//GETTING SHOPS DETAILS FOR OFFICE USE  
export const getItemInfoOfcView = createAsyncThunk(
    'itemsReducer/getItemInfoOfcView',
    async(id,{ dispatch })=>{
        const url=`${BASE_URL}api/onlitms/itemcmlofc/${id}/${getUserData().userId}`;
       
        
        try{
            const request = await axios.get(url,getAuthHeader()).then(
                
               
              );
             // JSONbigint.parse(request.data);
           

             let r1 = JSONBigInt.parse(request.request.response);
             let jsonStr=JSONBigInt.stringify(r1);
             
 
             const jsonStr1= jsonStr.replace(new RegExp('"onlineId":([0-9]+),',"g"),'"onlineId":"$1",')
             const jsonStr2= jsonStr1.replace(new RegExp('"shopId":([0-9]+),',"g"),'"shopId":"$1",')
              const ddd=JSON.parse(jsonStr2);
             
            
            return ddd.items;
        } catch(error){
            dispatch(errorGlobal(error.response.data.message))
            throw error
        }

        
    }
)
    
//ITEM STATUS CHANGING  IN OFFICE 
export const itemtatusChange = createAsyncThunk(
    'itemsReducer/itemtatusChange',
    async({data,addURL},{ dispatch})=>{
        
        try{
            const url=`${BASE_URL}${addURL}`;
            console.log("333333333");
            console.log(url);
        console.log(data);
        console.log("333333333");

            const category = await axios.post(url,data,getAuthHeader());
            

            console.log(url);
            if(category!=null)
            {
                console.log(category);
                console.log("333333333");
                

                if(category.data.message==="success"){
                    dispatch(successGlobal('success fully approved !!'))
                }
                else{
                    dispatch(errorGlobal('kindly check your status!!'))
                }
            }
        
            
            return category.data;
        } catch(error){
            
            dispatch(errorGlobal(error.response.data.message))
            throw error
        }
    }
)

// GETTING Items FOR HOME PAGE 
export const homeLoadItems = createAsyncThunk(
    'itemsReducer/homeLoadItems',
    async(sort,{ dispatch, getState })=>{
        console.log("12121212121")
        try{
            
            //const url=`${BASE_URL}api/shops/headlines/${getUserData().userId}/2/0`;
           const url=`${BASE_URL}api/onlitms/headlines/${getUserData().userId}/${sort.limit}/${sort.skip}`;
            console.log("1111111111");
            console.log(url);
            console.log("111111111111111");
            const request = await axios.get(url,getAuthHeader());

              let r1 = JSONBigInt.parse(request.request.response);
              let jsonStr=JSONBigInt.stringify(r1);
              
  
              const jsonStr1= jsonStr.replace(new RegExp('"onlineId":([0-9]+),',"g"),'"onlineId":"$1",')
              const jsonStr2= jsonStr1.replace(new RegExp('"shopId":([0-9]+),',"g"),'"shopId":"$1",')
               const ddd=JSON.parse(jsonStr2);
               console.log("66666666666");
               console.log(ddd);
               console.log("666666");
              //JSONbigint.parse(news.data);

              console.log("4444444");

              console.log(getState());

              console.log("4444444");
              

            const state = getState().itemsReducer.items;
            
            


            
             const prevState = [...state];
            const newState = [...prevState,...ddd.itemsHeaders]
            console.log("6666666666688888");
               console.log(newState);
               console.log("666666777");
            return { newState,sort }
        } catch(error){
            dispatch(errorGlobal(error.response.data.message))
            console.log("6666666");
            console.log(error.response.data.message);
            console.log("6666666");
            throw error
        }
    }
)